import SiteScheduleIndex from '@/views/sites/SiteScheduleIndex.vue'
import SiteScheduleCreate from '@/views/sites/SiteScheduleCreate.vue'
import SiteScheduleEdit from '@/views/sites/SiteScheduleEdit.vue'
import SiteScheduleShow from '@/views/sites/SiteScheduleShow.vue'

export default [
  {
    path: '/sites/:siteId/schedules',
    name: 'site-schedules',
    component: SiteScheduleIndex,
    meta: {
      requiresAuth: true,
      title: 'Site Schedules'
    }
  },
  {
    path: '/sites/:siteId/schedules/create',
    name: 'site-schedule-create',
    component: SiteScheduleCreate,
    meta: {
      requiresAuth: true,
      title: 'Create Schedule'
    }
  },
  {
    path: '/schedules/:scheduleId',
    name: 'site-schedule-show',
    component: SiteScheduleShow,
    meta: {
      requiresAuth: true,
      title: 'Schedule Details'
    }
  },
  {
    path: '/schedules/:scheduleId/edit',
    name: 'site-schedule-edit',
    component: SiteScheduleEdit,
    meta: {
      requiresAuth: true,
      title: 'Edit Schedule'
    }
  }
]
